import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import workflow from './modules/workflow'
import files from './modules/files'
import mark from './modules/mark'
import guild from './modules/guild'
import auth from './modules/auth'

Vue.use(Vuex);

const durableData = (options = {
  key: 'vuex',
  mutationName: 'mutationName',
  storage: window.localStorage
}) => {
  const key = options.key;
  const mutationName = options.mutationName;
  const storage = options.storage || ((window && window.localStorage));
  return store => {
    const localInfo = storage.getItem(key);
    if (localInfo) {
      store.dispatch(mutationName, localInfo);
    }
    store.subscribe(() => {
    })
  }
};

export default new Vuex.Store({
  modules: {
    app,
    workflow,
    files,
    mark,
    guild,
    auth
  },
  plugins: [
    durableData({key: 'userInfo', mutationName: 'setUserInfo'}),
    // durableData({key: 'userPermission', mutationName: 'setUserPermission'}),
    durableData({key: 'currentGuildInfo', mutationName: 'setGuildInfo'}),
    durableData({key: 'id', mutationName: 'setGuildInfo'}),
    durableData({key: 'guildPermission', mutationName: 'setGuildPermission'})
  ]
})
